<template>
  <div class="color-palette clearfix">
    <div class="palette-button color-palette-item" data-cmd="setColor" data-arg="{{ color }}"
         v-for="(idx, color) in state.AVAILABLE_COLORS">
      <div class="color-fill" v-bind:style="{ 'background-color': color }"></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

  $w: 40px;

  .color-palette {
    width: $w * 6;
  }

  .color-palette-item {
    width: 40px;
    height: 30px;
    .color-fill {
      width: 20px;
      height: 20px;
      margin: 5px 10px;
      border: 1px solid black;
    }
  }
</style>

<script>
  import state from '../../data/state';

  export default{
    data(){
      return {
        state
      }
    },

  }
</script>



// WEBPACK FOOTER //
// SaveDialog.vue?459930ae